import { ResearchUnit } from '@/domain/research-unit/ResearchUnit';

export interface RestResearchUnit {
  id: number;
  name: string;
  acronym: string;
  url: string;
  department: string;
}

export const toResearchUnit = (restUmr: RestResearchUnit): ResearchUnit => {
  return {
    id: restUmr.id,
    name: restUmr.name,
    acronym: restUmr.acronym,
    url: restUmr.url,
    department: restUmr.department,
  };
};
